"use client";

import dynamic from "next/dynamic";

import { getTurnkeyConfig } from "@/config/turnkey";

// publicEnv is constant for the bundle's life, so compute once: a fresh config
// identity per render would churn the SDK's config effects.
const config = getTurnkeyConfig();

// Loads the SDK chunk (~150-250KB + CSS) only when Turnkey is provisioned. The
// gate below runs before this dynamic import fires, so inert envs never fetch it.
const TurnkeyProviderInner = dynamic(() => import("./turnkey-provider-inner"), { ssr: false });

export default function TurnkeyProvider({ children }: React.PropsWithChildren) {
  if (!config) return <>{children}</>;
  return <TurnkeyProviderInner config={config}>{children}</TurnkeyProviderInner>;
}
